<template>
  <b-list-group class="settings-nav mb-4 mb-md-0">
    <b-list-group-item id="hyperSettingGeneralLink" to="/settings/general"
      >General</b-list-group-item
    >
    <b-list-group-item id="hyperSettingBillingLink" to="/settings/billing"
      >Billing</b-list-group-item
    >
    <b-list-group-item id="hyperSettingPaymentLink" to="/settings/payment"
      >Payment</b-list-group-item
    >
    <b-list-group-item
      id="hyperSettingSubcriptionLink"
      to="/settings/subscriptions"
      >Subscriptions</b-list-group-item
    >
    <b-list-group-item id="hyperSettingInvoicesLink" to="/settings/invoices"
      >Invoices</b-list-group-item
    >
  </b-list-group>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  }
};
</script>
<style lang="scss" scoped>
.settings-nav {
  top: 2rem;
  position: sticky;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: none;
}
</style>
